import React, { useState, useEffect, useRef } from "react";
import { COUNTRY_DIAL_CODES } from "../../../Constants/countryDialCodes";
import "./CountryCodeSelect.css";

const CountryCodeSelect = ({
  value,
  onChange,
  placeholder = "Select Country Code",
  error = "",
  theme = "light",
  className = "",
  style = {},
}) => {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShow(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = COUNTRY_DIAL_CODES.filter(
    (item) =>
      item.country.toLowerCase().includes(search.toLowerCase()) ||
      item.code.toLowerCase().includes(search.toLowerCase())
  );

  const selectedOption = COUNTRY_DIAL_CODES.find((item) => item.code === value);
  const displayValue = selectedOption ? `${selectedOption.code} (${selectedOption.country.split(' ')[0]})` : placeholder;

  const isDark = theme === "dark";

  return (
    <div className={`country-code-select-wrapper ${className}`} ref={dropdownRef} style={{ position: 'relative', width: '100%', ...style }}>
      {/* Dropdown Toggle */}
      <div
        className={`form-select ${error ? "is-invalid" : ""}`}
        onClick={() => setShow(!show)}
        style={{
          cursor: 'pointer',
          minHeight: '38px',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: isDark ? '#1a1a1a' : '#fff',
          border: error ? '1px solid #dc3545' : isDark ? '1px solid #444' : '1px solid #ced4da',
          color: value ? (isDark ? '#fff' : '#212529') : (isDark ? '#aaa' : '#6c757d'),
          borderRadius: '0.375rem',
          padding: '0 0.75rem',
          fontSize: isDark ? '13px' : '1rem',
          transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
        }}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {displayValue}
        </span>
      </div>

      {/* Dropdown Menu */}
      {show && (
        <div 
          style={{ 
            position: 'absolute', 
            top: '100%', 
            left: 0, 
            right: 0, 
            zIndex: 1050, 
            background: isDark ? '#1a1a1a' : '#fff', 
            border: isDark ? '1px solid #444' : '1px solid #ced4da', 
            borderRadius: '0.375rem', 
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)', 
            marginTop: '2px' 
          }}
        >
          {/* Search Input */}
          <div style={{ padding: '8px' }}>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search code or country..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
              style={isDark ? { background: '#2a2a2a', color: '#fff', border: '1px solid #555' } : {}}
            />
          </div>

          {/* Options List */}
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((item, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    onChange(item.code);
                    setShow(false);
                    setSearch("");
                  }}
                  style={{ 
                    padding: '8px 12px', 
                    cursor: 'pointer', 
                    fontSize: '14px', 
                    borderBottom: isDark ? '1px solid #333' : '1px solid #f0f0f0',
                    color: isDark ? '#fff' : '#212529',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                  onMouseEnter={(e) => e.target.style.background = isDark ? '#333' : '#f8f9fa'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  <span style={{ fontWeight: 500 }}>{item.code}</span>
                  <span style={{ fontSize: '12px', opacity: 0.8 }}>{item.country}</span>
                </div>
              ))
            ) : (
              <div style={{ padding: '8px 12px', color: '#6c757d', fontSize: '14px' }}>No matches found</div>
            )}
          </div>
        </div>
      )}

      {/* Error Message */}
      {error && <div className="invalid-feedback d-block" style={{ fontSize: '13px', marginTop: '4px' }}>{error}</div>}
    </div>
  );
};

export default CountryCodeSelect;
